import * as LucideIcons from "lucide-react";
import * as FontAwesome from "react-icons/fa";
import * as MaterialDesign from "react-icons/md";
import * as Bootstrap from "react-icons/bs";
import * as Feather from "react-icons/fi";
import * as Heroicons from "react-icons/hi";
import * as RemixIcon from "react-icons/ri";
import { Folder } from "lucide-react";

interface CategoryIconProps {
  iconName?: string;
  iconLibrary?: string;
  className?: string;
}

const ICON_LIBRARIES = {
  "lucide-react": LucideIcons,
  "font-awesome": FontAwesome,
  "material-design": MaterialDesign,
  bootstrap: Bootstrap,
  feather: Feather,
  heroicons: Heroicons,
  "remix-icon": RemixIcon,
};

export function CategoryIcon({
  iconName,
  iconLibrary = "lucide-react",
  className = "h-4 w-4 text-primary",
}: CategoryIconProps) {
  // Se não houver ícone definido, retorna o ícone padrão
  if (!iconName) {
    return <Folder className={className} />;
  }

  // Busca a biblioteca correta
  const library = ICON_LIBRARIES[iconLibrary as keyof typeof ICON_LIBRARIES];
  if (!library) {
    return <Folder className={className} />;
  }

  // Busca o ícone dinâmico
  const IconComponent = (library as any)[iconName];
  if (!IconComponent) {
    return <Folder className={className} />;
  }

  return <IconComponent className={className} />;
}
